module.exports = __webpack_public_path__ + "img/SAP_9060.3edabfa4.jpg";